import type { SVGProps } from 'react';

type LibraryNavIconProps = SVGProps<SVGSVGElement>;

/** Figma Left Nav library icon (node 4091:35740) — 20×20 open book. */
export function LibraryNavIcon({
  width = 20,
  height = 20,
  strokeWidth = 1.5,
  className,
  ...props
}: LibraryNavIconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
      {...props}
    >
      <path
        d="M10 17.4974V5.83073C10 4.91025 10.7462 4.16406 11.6667 4.16406H17.8333C18.1095 4.16406 18.3333 4.38792 18.3333 4.66406V15.5926"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <path
        d="M10.0013 17.4974V5.83073C10.0013 4.91025 9.25514 4.16406 8.33464 4.16406H2.16797C1.89183 4.16406 1.66797 4.38792 1.66797 4.66406V15.5926"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <path
        d="M11.668 15.8359H18.3346"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <path
        d="M8.33464 15.8359H1.66797"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <path
        d="M10 17.5026C10 16.5821 10.7462 15.8359 11.6667 15.8359"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.9987 17.5026C9.9987 16.5821 9.25253 15.8359 8.33203 15.8359"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
